import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    standalone: true,
    selector: 'sh-fixed-header-panel',
    templateUrl: './fixed-header-panel.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ShFixedHeaderPanelComponent {}
